import { forwardRef, Ref, type SVGProps } from 'react';

const SvgCoral = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#033532"
      d="m10.94 12.25-.133 1.795 1.742-.288.033-1.163 1.6-.574.29 1.334 1.104-.75-.529-2.03 1.241-.652.782.781.39-2.738 1.96.13-.457 3.915-2.48 3.586-4.876 1.25 1.027 2.756H6.618l.963-2.59-1.494-2.905-4.264-1.233L.741 8.611l1.457-3.04 1.9 1.456-1.02 2.635.554 1.634 1.28-.097.611-2.874-1.632-3 .523-2.284 2.212.426-.235 1.617.611 1.352.544-2.286-.457-1.5L9.202 2l.84 1.856-.904 3.28-1.926 1.68-.271 3.61 1.619-.398.473-.88-1.03-2.169 1.93-.878.592 1.333 1.471-.786-.984-2.638 1.79.066.795 1.442.718-1.89-1.115-2.46 2.683-.475-.076 1.937.858-.517.57-2.113 2.185.307-1.155 3.672L15.8 7.045l-1.205 2.87z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCoral);
export default ForwardRef;
